import CustomTextField from "components/CustomTextField";
import { Col, Row, Card, CardBody, CardHeader, CardTitle } from "reactstrap";
import { useParams, useLocation } from "react-router-dom";
import { Modal, Button, Spinner, Table } from "react-bootstrap";
import { toast } from "react-toastify";
import {
  useGetAllFamilyOfUsersQuery,
  useCreateFamilyDetailsMutation,
  useUpdateFamilyByIdMutation,
} from "./farmerApiSlice";
import { useEffect, useState } from "react";
import FarmerNoResponse from "./FarmerNoResponse";
import swal from "sweetalert";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faRotateLeft } from "@fortawesome/free-solid-svg-icons";
import { LoaderDesign } from "./LoaderDesign";
import { Badge } from "antd";
import CardSkeleton from "components/CardSkeleton";
import { Divider } from "@mui/material";
const FarmerDetailsFamily = () => {
  const { id } = useParams();
  const location = useLocation();
  const fullname = location.state?.fullname || "";
  const [FamilyList, setFamilyList] = useState([]);
  const [showError, setError] = useState(false);
  const [createFamily] = useCreateFamilyDetailsMutation();
  const [updateFamily] = useUpdateFamilyByIdMutation();
  const [disableButton, disableSubmitBtn] = useState(false);
  const { data: data, refetch, isLoading } = useGetAllFamilyOfUsersQuery(id);
  const [showAddModal, setshowAddModal] = useState(false);
  const [SubmitButtonApi, setSubmitButtonApi] = useState(false);
  const [updateId, setUpdateId] = useState("");
  const [showLoader, setLoader] = useState(false);
  const [Group, editGroup] = useState({
    name: "",
    phone_number: "",
    gender: "",
    DOB: "",
    occupation: "",
    relation: "",
    education: "",
    income: "",
    income_source: "",
    income_tenure: "Annual",
    expense: "",
    expense_tenure: "",
    expense_type: "",
  });
  useEffect(() => {
    const userFromApi = data?.data ? data?.data : FamilyList;
    if (userFromApi !== undefined) setFamilyList(userFromApi);
  }, [data]);

  const AddModal = (updateButtonTag, list) => {
    if (updateButtonTag) {
      setSubmitButtonApi(true);
      setUpdateId(list.id);
    }

    let currentList = {
      name: list.name,
      phone_number: list.phone_number,
      gender: list.gender,
      DOB: list.DOB,
      occupation: list.occupation,
      relation: list.relation,
      education: list.education,
      income: list.income,
      income_source: list.income_source,
      income_tenure: list.income_tenure,
      expense: list.expense,
      expense_tenure: list.expense_tenure,
      expense_type: list.expense_type,
    };
    editGroup(currentList);
    setshowAddModal(true);
  };
  const handleClose = () => {
    setshowAddModal(false);
    setError(false);
    setSubmitButtonApi(false);
    setUpdateId("");
    editGroup({
      name: "",
      phone_number: "",
      gender: "",
      DOB: "",
      occupation: "",
      relation: "",
      education: "",
      income: "",
      income_source: "",
      income_tenure: "Annual",
      expense: "",
      expense_tenure: "",
      expense_type: "",
    });
    disableSubmitBtn(false);
  };
  const onInputChange = (event) => {
    if (event.target.name == "DOB") {
      var date2 = event.target.value
        .split("-")
        .reverse()
        .join("-");
      editGroup({
        ...Group,
        [event.target.name]: date2,
      });
    } else {
      editGroup({
        ...Group,
        [event.target.name]: event.target.value,
      });
    }
  };

  const AddFamilytSubmit = (e) => {
    e.preventDefault();
    disableSubmitBtn(true);
    if (!SubmitButtonApi) {
      createFamily({ id: id, payload: Group })
        .unwrap()
        .then((data) => {
          // toast.success("Family Member Created")
          swal("Member Created Successfully", {
            buttons: false,
            icon: "success",
            title: "Member Created Detail",
            timer: 1500,
          });
          setshowAddModal(false);
          disableSubmitBtn(false);
          refetch();
        })
        .catch((error) => {
          toast.error("Error while Creating Member");
          disableSubmitBtn(false);
          return;
        });
    } else {
      updateFamily({ id: updateId, payload: Group })
        .unwrap()
        .then((data) => {
          swal("Member Updated Successfully", {
            buttons: false,
            icon: "success",
            title: "Member Updated Detail",
            timer: 1500,
          });
          // toast.success("Family Member Updated")
          setshowAddModal(false);
          disableSubmitBtn(false);
          refetch();
        })
        .catch((error) => {
          toast.error("Error while Updating Member");
          disableSubmitBtn(false);
          return;
        });
    }
  };
  const ReloadApplication = () => {
    setLoader(true);
    setTimeout(() => {
      refetch();
      setLoader(false);
    }, 1500);
  };

  return (
    <Card className="globalboxshadow">
    
       <div
              className="d-flex justify-content-between  align-items-center "
              style={{ borderRadius: "5px",backgroundColor:"#f1f1f1" }}
            >
              <div className="heading-title mt-lg-0 mt-2 py-3 ">
                      <h5
                        className="mx-4 "
                        style={{
                          fontSize: "18px",
                          color: "black",
                        }}
                      >
                        <i
                          className="mdi mdi-account-hard-hat me-2"
                          style={{ fontSize: "1.5rem" }}
                        ></i>
                        {fullname}
                      </h5>
                    </div>
              <div
                className="d-flex justify-content-end align-items-center flex-wrap"
                style={{ gap: "6px" }}
              >
                <Button
                  id="AddDetails99"
                  type=""
                  className="buttonOrangeDefaultColor"
                  onClick={() => AddModal(false, Group)}
                  size="sm"
                >
                  Add <i className="mdi mdi-account-plus custom-btn-fs fs-6"></i>
                </Button>
                <Button
                  className="bg-transparent text-black fs-6 reloadButton me-2"
                  size="sm"
                  onClick={ReloadApplication}
                >
                 Reload <FontAwesomeIcon icon={faRotateLeft} />
                </Button>
                </div>
            </div>
      {isLoading ? (
        <div className="mt-4">
          <CardSkeleton />
        </div>
      ) : FamilyList.length === 0 ? (
        <FarmerNoResponse />
      ) : (
        <div className="border-lg transparent_card">
          <div className="p-0">
            <Col lg="12">
            <div
                  className="table-editor table-responsive d-lg-block d-md-block d-none"
                  id="familyid"
                  data-mdb-entries="5"
                  data-mdb-entries-options="[5, 10, 15]"
                >
              
<div className="">
  {FamilyList &&
    FamilyList.map((member, index) => (
      <div className="d-lg-block d-md-none d-none transparent_card custom_mb" key={index}>
                       <Divider style={{ borderTop: "2px dotted orange",marginBottom:"5px" }} />
         
        <div className="p-3">
         

          <div className="row text-gray">
            {/* Name, Age, Gender */}
            <div className="col-md-2 mb-3">
              <CustomTextField type="text" name="name" value={member.name || "-"} disabled />
            </div>
            <div className="col-md-2 mb-3">
              <CustomTextField type="text" name="phone_number" value={member.phone_number || "-"} disabled />
            </div>
            

            {/* Phone, Relation, Occupation */}
           
            <div className="col-md-2 mb-3">
              <CustomTextField type="text" name="relation" value={member.relation || "-"} disabled />
            </div>
            <div className="col-md-2 mb-3">
              <CustomTextField type="text" name="occupation" value={member.occupation || "-"} disabled />
            </div>
            <div className="col-md-1 mb-3">
              <CustomTextField type="text" name="age" value={member.age || "-"} disabled />
            </div>
            <div className="col-md-1 mb-3">
              <CustomTextField type="text" name="gender" value={member.gender || "-"} disabled />
            </div>

            {/* Education, Income, Income Source */}
            <div className="col-md-2 mb-3">
              <CustomTextField type="text" name="education" value={member.education || "-"} disabled />
            </div>
{/*            
            <div className="col-md-2 mb-3">
              <CustomTextField type="text" name="income_source" value={member.income_source || "N/A"} disabled />
            </div> */}

            {/* Income Tenure, Expense, Expense Type */}
            <div className="col-md-2 mb-3">
              <CustomTextField type="text" name="income_tenure" value={member.income_tenure || "-"} disabled />
            </div>
            <div className="col-md-2 mb-3">
              <CustomTextField type="text" name="income" value={member.income || "N/A"} disabled />
            </div>
          
            <div className="col-md-2 mb-3">
              <CustomTextField type="text" name="expense_type" value={member.expense_type || "N/A"} disabled />
            </div>

            {/* Expense Tenure */}
            <div className="col-md-2 mb-3">
              <CustomTextField type="text" name="expense_tenure" value={member.expense_tenure || "N/A"} disabled />
            </div>
            <div className="col-md-2 mb-3">
              <CustomTextField type="text" name="expense" value={member.expense || "-"} disabled />
            </div>
          </div>
          <div className="col-12 text-end p-2 mt-2 mb-0 d-lg-block d-md-none d-none">
                        
                        <Button
                          id="editDetails"
                          type=""
                          className="buttonOrangeDefaultColor"
                          onClick={() => AddModal(true, member)}
                          size="sm"
                        >
                          Edit&nbsp; <FontAwesomeIcon icon={faPenToSquare} />
                        </Button>
                     
                    </div>
        </div>
      </div>
    ))}
</div>




                </div>
            </Col>
            <Col xs="12">
              <div className="d-flex flex-lg-row flex-md-row flex-wrap  d-lg-none d-md-none d-block">
                {FamilyList && FamilyList.length > 0 ? (
                  FamilyList.map((fmd, index) => (
                    <Card
                      className="transparent_card custom_mb w-100 mb-2"
                      key={index}
                      lg="10"
                      md="5"
                      xs="12"
                    >
                      <CardBody className="p-1 p-lg-3">
                        <div className="hover-shadow d-lg-none d-md-block d-block rounded-3 bg-white p-3">
                          <CardTitle className="d-flex align-items-center justify-content-between mb-2">
                            <div className="d-flex align-items-center justify-content-between w-100">
                              <div>
                                <span className="font-weight-bold">
                                  <span className="text-success mx-1">
                                    {fmd.name || "N/A"}{" "}
                                  </span>
                                  <p className="text-secondary mx-1">
                                    {fmd?.occupation}
                                  </p>
                                </span>
                              </div>
                              <div className="">
                                <FontAwesomeIcon
                                  onClick={() => AddModal(true, fmd)}
                                  className="mx-1"
                                  icon={faPenToSquare}
                                  style={{
                                    color: "orange",
                                    cursor: "pointer",
                                  }}
                                />
                              </div>
                            </div>
                          </CardTitle>
                          <hr
                            className="mt-0 mb-2"
                            style={{ borderColor: "#FF8C00" }}
                          />

                          <Table className="table mb-0">
                            <tbody>
                              <tr>
                                <th>Mobile:</th>

                                <td>
                                  {" "}
                                  <span>{fmd.phone_number || "N/A"}</span>
                                </td>
                              </tr>

                              <tr>
                                <th>Gender:</th>
                                <td>
                                  <span>{fmd.gender || "N/A"}</span>
                                </td>
                              </tr>

                              <tr>
                                <th>Age:</th>
                                <td>
                                  <span>{fmd.age || "N/A"}</span>
                                </td>
                              </tr>

                              <tr>
                                <th>Occupation:</th>
                                <td>
                                  <span>{fmd.occupation || "N/A"}</span>
                                </td>
                              </tr>

                              <tr>
                                <th>Relation:</th>
                                <td>
                                  <span>{fmd.relation || "N/A"}</span>
                                </td>
                              </tr>
                              <tr>
                                <th>Education:</th>
                                <td>
                                  <span>{fmd.education || "N/A"}</span>
                                </td>
                              </tr>
                              <tr>
                                <th>Income:</th>
                                <td>
                                  <span>{fmd.income || "N/A"}</span>
                                </td>
                              </tr>
                              <tr>
                                <th>Expense:</th>
                                <td>
                                  <span>{fmd.expense || "N/A"}</span>
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                      </CardBody>
                    </Card>
                  ))
                ) : (
                  <div className="text-center bg-white rounded-3 d-flex justify-content-center py-5 w-100">
                    <h5>No Data Available</h5>
                  </div>
                )}
              </div>
            </Col>
          </div>
        </div>
      )}

      <Modal show={showAddModal} onHide={handleClose} size="xl">
        <Modal.Header closeButton>
          <Modal.Title style={{ color: "" }} className="fw-bold">
            {SubmitButtonApi ? "Update" : "Add"} Family Member
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-1 p-md-4 p-lg-4">
          <form onSubmit={AddFamilytSubmit}>
            <Row className="text-gray">
              <Col lg="4" className="mb-2  ">
                <CustomTextField
                  type="text"
                  required
                  name="name"
                  value={Group.name}
                  onChange={onInputChange}
                />
              </Col>
              <Col lg="4" className="mb-4">
                <CustomTextField
                  type="text"
                  maxlength="10"
                  required
                  name="phone_number"
                  value={Group.phone_number}
                  onChange={onInputChange}
                />
              </Col>
              <Col lg="4" className="mb-4">
                <CustomTextField
                  type="select"
                  name="gender"
                  required
                   className="text-gray"
                  value={Group.gender}
                  style={{ padding:"7px" }}
                  onChange={onInputChange}
                >
                  <option value="">Select</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="others">Others</option>
                </CustomTextField>
              </Col>
              <Col lg="4" className="mb-4">
                <CustomTextField
                  type="date"
                  required
                  name="DOB"
                  defaultValue={Group.DOB.split("-")
                    .reverse()
                    .join("-")}
                  onChange={onInputChange}
                />
              </Col>
              <Col lg="4" className="mb-4">
                <CustomTextField
                  type="text"
                  required
                  name="occupation"
                  value={Group.occupation}
                  onChange={onInputChange}
                />
              </Col>
              <Col lg="4" className="mb-4">
                <CustomTextField
                  type="select"
                  required
                  name="relation"
                   className="text-gray"
                  value={Group.relation}
                  style={{ padding:"7px" }}
                  onChange={onInputChange}
                >
                  <option value="">Select</option>
                  <option value="Father">Father</option>
                  <option value="Mother">Mother</option>
                  <option value="Brother">Brother</option>
                  <option value="Sister">Sister</option>
                  <option value="others">Uncle</option>
                </CustomTextField>
              </Col>
              <Col lg="4" className="mb-4">
                <CustomTextField
                  type="text"
                  required
                  name="education"
                  value={Group.education}
                  onChange={onInputChange}
                />
              </Col>
              <Col lg="4" className="mb-4">
                <CustomTextField
                  type="text"
                  required
                  name="income"
                  value={Group.income}
                  onChange={onInputChange}
                />
              </Col>
              {/* <Col lg="4" className="mb-4">
                <CustomTextField
                  type="select"
                  required
                  name="income_source"
                   className="text-gray"
                  value={Group.income_source}
                  style={{ padding:"7px" }}
                  onChange={onInputChange}
                >
                  <option value="">Select</option>
                  <option value="Service">Service</option>
                  <option value="Business">Business</option>
                  <option value="Pocket Money">Pocket Money</option>
                </CustomTextField>
              </Col> */}
              <Col lg="4" className="mb-4">
                <CustomTextField
                  type="text"
                  required
                  name="income_tenure"
                  value={Group.income_tenure}
                  onChange={onInputChange}
                  disabled
                />
              </Col>
              <Col lg="4" className="mb-4">
                <CustomTextField
                  type="text"
                  required
                  name="expense"
                  value={Group.expense}
                  onChange={onInputChange}
                />
              </Col>

              <Col lg="4" className="mb-4">
                <CustomTextField
                  type="text"
                  required
                  name="expense_tenure"
                  value={Group.expense_tenure}
                  onChange={onInputChange}
                />
              </Col>
              <Col lg="4" className="mb-4">
                <CustomTextField
                  type="select"
                  required
                  name="expense_type"
                  className="text-gray"
                  value={Group.expense_type}
                  style={{ padding:"7px" }}
                  onChange={onInputChange}
                >
                  <option value="">Select</option>

                  <option value="Education">Education</option>
                  <option value="Lifestyle">Lifestyle</option>
                  <option value="Medical">Medical</option>
                  <option value="Food">Food</option>
                </CustomTextField>
              </Col>
            </Row>

            <Button
              type="submit"
              className={`submit-btn `}
              disabled={disableButton ? true : false}
              style={{ float: "right" }}
              size="sm"
            >
              Submit &nbsp;
              {disableButton ? <Spinner animation="border" size="sm" /> : ""}
            </Button>
            {showError ? (
              <div style={{ color: "red" }}>
                All The fields are mandatory **
              </div>
            ) : (
              ""
            )}
          </form>
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
    </Card>
  );
};

export default FarmerDetailsFamily;
